import { useState, useEffect } from "react";
import { useMap } from "react-leaflet";


export function useUserLocation(onLocationFound, delay = 500) {
    const map = useMap();
    const [userPosition, setUserPosition] = useState(null);
    const [hasZoomed, setHasZoomed] = useState(false);

    useEffect(() => {
        if (!map || hasZoomed) return;

        // Väntar några sekunder för sidan att ladda innan man hämtar användarens position
        const locationTimer = setTimeout(() => {
            // request användarens position
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const { latitude, longitude } = position.coords;
                        const userPos = [latitude, longitude];
                        setUserPosition(userPos);
                        
                        // Callback när position hittas
                        if (onLocationFound) {
                            onLocationFound(userPos);
                        }
                        
                        // Centrerar kartan på användarens position
                        map.setView(userPos, 12, {
                            animate: true,
                            duration: 1.5,
                        });
                        
                        // Förhindrar att zoom sker flera gånger
                        setHasZoomed(true);
                    },
                    (error) => {
                        console.log('Geolocation error:', error.message);
                        // Hantera fel vid positionhämtning om nödvändigt
                    }
                );
            }
        }, delay);

        return () => clearTimeout(locationTimer);
    }, [map, hasZoomed, onLocationFound, delay]);

    return { userPosition };
}
